// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export interface CosmosHeaders {
  [key: string]: string | boolean | number;
}
